export default __webpack_public_path__ + "static/sampleCode-8b199ae30bbb8e391ad1ac821e212577.png";